var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridCardBasic',{attrs:{"data":_vm.activity,"empty":"Aucune activité récente","minCardSize":"250px"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('CardActivity',{attrs:{"activity":data}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }